/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The DashboardStatsPendingActivation model module.
 * @module model/DashboardStatsPendingActivation
 * @version v0.3
 */
export default class DashboardStatsPendingActivation {
  /**
   * Constructs a new <code>DashboardStatsPendingActivation</code>.
   * @alias module:model/DashboardStatsPendingActivation
   * @class
   * @param total {Number}
   * @param overdue {Number}
   */
  constructor(total, overdue) {
    this.total = total;
    this.overdue = overdue;
  }

  /**
   * Constructs a <code>DashboardStatsPendingActivation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardStatsPendingActivation} obj Optional instance to populate.
   * @return {module:model/DashboardStatsPendingActivation} The populated <code>DashboardStatsPendingActivation</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DashboardStatsPendingActivation();
      if (data.hasOwnProperty('total'))
        obj.total = ApiClient.convertToType(data['total'], 'Number');
      if (data.hasOwnProperty('overdue'))
        obj.overdue = ApiClient.convertToType(data['overdue'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} total
 */
DashboardStatsPendingActivation.prototype.total = undefined;

/**
 * @member {Number} overdue
 */
DashboardStatsPendingActivation.prototype.overdue = undefined;
